export default class Service {
  constructor() {
    this.name = new String();
    this.text = new String();
    this.miniature = new String();
  }
}
